import { render, staticRenderFns } from "./TicketScaleSummary.vue?vue&type=template&id=2a71e488&"
import script from "./TicketScaleSummary.vue?vue&type=script&lang=js&"
export * from "./TicketScaleSummary.vue?vue&type=script&lang=js&"
import style0 from "./TicketScaleSummary.vue?vue&type=style&index=0&id=2a71e488&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports